import { render, staticRenderFns } from "./OrderCustomer.vue?vue&type=template&id=5ef45998&scoped=true"
import script from "./OrderCustomer.vue?vue&type=script&lang=js"
export * from "./OrderCustomer.vue?vue&type=script&lang=js"
import style0 from "./OrderCustomer.vue?vue&type=style&index=0&id=5ef45998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef45998",
  null
  
)

export default component.exports